import { useCallback, useState } from 'react';
import { Device } from '@raydiant/api-client-js';
import Dialog, {
  DialogHeader,
  DialogHeading,
  DialogSubheading,
} from '@raydiant/raydial/components/Dialog';
import TextField from '@raydiant/raydial/components/TextField';
import Modal from '@raydiant/raydial/components/Modal';
import Text from '@raydiant/raydial/components/Text';
import Button from '@raydiant/raydial/components/Button';

interface UnregisterDeviceConfirmationProps {
  device: Device;
  open: boolean;
  onConfirm: ((result: boolean) => void) | null;
}

const UnregisterDeviceConfirmationV2 = ({
  device,
  open,
  onConfirm,
}: UnregisterDeviceConfirmationProps) => {
  const [inputValue, setInputValue] = useState<string | null>(null);

  const handleCancel = useCallback(() => {
    if (!onConfirm) return;
    onConfirm(false);
  }, [onConfirm]);

  const handleOk = useCallback(
    (e) => {
      e.preventDefault();
      if (!onConfirm) return;
      onConfirm(true);
    },
    [onConfirm],
  );

  const isRemoveDisabled = (inputValue ?? '').toLowerCase() !== 'delete';

  return (
    <Modal
      isOpen={open}
      className="text-black overflow-auto"
      style={{ zIndex: 9999 }}
    >
      <Dialog showCloseButton onClose={handleCancel}>
        <DialogHeader>
          <DialogHeading>Confirm delete device</DialogHeading>
          <DialogSubheading>
            <div className="mt-11 text-black">
              <div className="mb-4">
                <Text className="text-base">
                  Are you sure you want to delete the “{device.name}” device?
                  This device may have content published to it, and this cannot
                  be undone.
                </Text>
              </div>
              <div>
                <Text className="text-base">
                  To proceed, please type DELETE below:
                </Text>
              </div>
            </div>
          </DialogSubheading>
        </DialogHeader>
        <form className="px-4" onSubmit={handleOk}>
          <div className="mt-4 mb-8">
            <TextField
              autoFocus
              label=""
              value={inputValue ?? ''}
              placeholder="Enter DELETE"
              onChange={setInputValue}
            />
          </div>
          <div className="flex flex-col pb-4 md:flex-row md:justify-between">
            <Button
              className="w-full md:max-w-[270px]"
              variant="secondary"
              onPress={handleCancel}
            >
              Cancel
            </Button>
            <Button
              className="w-full md:max-w-[270px]"
              type="submit"
              variant="caution"
              isDisabled={isRemoveDisabled}
            >
              Confirm Delete Device
            </Button>
          </div>
        </form>
      </Dialog>
    </Modal>
  );
};

export default UnregisterDeviceConfirmationV2;
